<template>
  <div>
    <b-sidebar
      v-if="windowWidth < 1200"
      v-model="showModal"
      class="d-md-block d-xl-none"
      bg-variant="white"
      width="500px"
      no-header
      no-scroll
      right
      backdrop
      shadow
    >
      <UserDetails />
    </b-sidebar>
    <UserDetails v-if="windowWidth >= 1200" class="d-md-none d-xl-block" />
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import UserDetails from './UserDetails.vue'
import { BSidebar, VBToggle } from 'bootstrap-vue'

export default {
  components: { BSidebar, UserDetails },
  directives: {
    'b-toggle': VBToggle,
    Ripple
  },
  computed: {
    showModal: {
      get() {
        return this.$store.state.userDetailsModal.showModal
      },
      set(value) {
        this.$store.dispatch('userDetailsModal/onChangeModal', { visible: value })
      }
    },
    windowWidth: {
      get() {
        return this.$store.state.app.windowWidth
      }
    }
  }
}
</script>

<style lang="scss">
.b-sidebar-body {
  padding-left: 1rem;
  padding-right: 1rem;
}

.details {
  padding: 0.5rem;
}
</style>
